import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import ActiveIcon from "../vectors/ActiveIcon";
const bibIcon = require("../../styles/bib-icon.svg");

interface FilterByTextProps {
  currentText: string;
  updateFilter: Function;
  expanded: boolean;
  collapseFilter: Function;
  isActive: boolean;
  pageConfig: {
    accentColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}
class FilterByText extends React.Component<FilterByTextProps> {
  componentWillReceiveProps(nextProps: any) {
    //@ts-ignore
    document.getElementById("photoText").value = nextProps.currentText;
  }

  //@ts-ignore
  enteredText = () => document.getElementById("photoText").value;

  submitText = (e: any) => {
    e.preventDefault();
    //@ts-ignore
    (window.dataLayer || []).push({ event: "filterAlbumByBibNumber" });
    this.props.updateFilter(this.enteredText());
    this.props.trackFilterEvents("bibNumber");
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingFive">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={bibIcon} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              aria-expanded={this.props.expanded}
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              onClick={e => this.props.collapseFilter(e, "bib")}
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapseFive"
              aria-controls="collapseFive"
            >
              Bib number
            </a>
          </h4>
        </div>
        <div
          id="collapseFive"
          className={
            "panel-collapse collapse " + (this.props.expanded ? "in" : "")
          }
          role="tabpanel"
          aria-labelledby="headingFive"
        >
          <div className="panel-body dv-text-filter">
            <form className="form-inline" onSubmit={this.submitText}>
              <div className="form-group">
                <input
                  id="photoText"
                  type="text"
                  className="form-control"
                  placeholder="Your bib number"
                  defaultValue={this.props.currentText}
                />
              </div>
              <button type="submit" className="btn btn-default btn-lg">
                <span className="fa fa-angle-right" />
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterByText;
